var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Modal', {
    attrs: {
      "width": "400",
      "mask-closable": _vm.uploadStatus !== 'uploading'
    },
    model: {
      value: _vm.modalOpened,
      callback: function ($$v) {
        _vm.modalOpened = $$v;
      },
      expression: "modalOpened"
    }
  }, [_c('p', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-cloud-upload-outline"
    }
  }), _c('span', {
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v("导入客户Excel")])], 1), _c('TimelineItem', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('p', {
    staticClass: "time"
  }, [_vm._v(" 1. 请先下载模板： "), _c('a', {
    attrs: {
      "href": "https://zhidawanwu.oss-cn-shenzhen.aliyuncs.com/public/%E5%AE%A2%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx",
      "target": "_blank"
    }
  }, [_vm._v("客户列表模板")])])]), _c('TimelineItem', [_c('p', {
    staticClass: "time"
  }, [_vm._v("2. 请按照模板写入客户数据")])]), _c('TimelineItem', [_c('p', {
    staticClass: "time"
  }, [_vm._v("3. 上传客户列表模板")]), _c('input', {
    ref: "inputFile",
    staticClass: "inputfile",
    attrs: {
      "type": "file",
      "name": "file",
      "id": "file"
    },
    on: {
      "change": function ($event) {
        return _vm.handlerUpload($event);
      }
    }
  }), _c('label', {
    staticClass: "custom-file-upload",
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "for": "file"
    }
  }, [_vm._v("导入客户")])]), _vm.uploadStatus ? _c('TimelineItem', [_c('p', {
    staticClass: "time"
  }, [_vm._v("4. 上传进度")]), _c('Alert', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "type": _vm.alertStatus
    }
  }, [_vm._v(_vm._s(_vm.uploadText))]), _c('Progress', {
    attrs: {
      "percent": _vm.completeProgress,
      "status": _vm.progressBarStatus
    }
  })], 1) : _vm._e(), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "disabled": _vm.uploadStatus === 'uploading',
      "loading": _vm.uploadStatus === 'uploading'
    },
    on: {
      "click": function ($event) {
        _vm.modalOpened = false;
      }
    }
  }, [_vm._v("取消")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }